import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import { logo } from "../../assets/images";

export default function Modal({ open, setOpen, text }) {
  return (
    <Dialog className="relative z-50" open={open} onClose={setOpen}>
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-black bg-opacity-65 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-xl bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4 flex flex-col justify-center items-center">
              <div>
                <img src={logo} className="h-[55px] md:h-[45px]" alt="Logo" />
              </div>
              <h1 className="font-semibold text-gray-900 text-[18px]">
                Join the waitlist
              </h1>
              <p className="font-normal text-gray-400 text-center">
                We'll keep you updated and reach out when the app launches
              </p>
              <p className="pt-6 pb-7">{text}</p>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
